import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface UseJobOptions {
  gcTime?: number;
  /** A missing or inaccessible job is a normal outcome (e.g. a CTC record's optional link): no retry, no toast. */
  optional?: boolean;
}

/** @registry Job detail by id; the canonical cache every job write refreshes. */
export function useJob(
  jobId: number | null | undefined,
  options?: UseJobOptions,
) {
  return useQuery({
    queryKey: queryKeys.jobs.detail(jobId ?? -1),
    queryFn: ({ signal }) =>
      jobApiClient.getById(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 0,
    gcTime: options?.gcTime,
    retry: options?.optional ? false : undefined,
    meta: {
      errorContext: 'job detail',
      suppressErrorToast: options?.optional ?? false,
    },
  });
}
